import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "font-bold mb-1"
};
const _hoisted_2 = {
  key: 0
};
export default /*#__PURE__*/_defineComponent({
  __name: 'Effects',
  props: {
    effects: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "title", {}, () => [_createTextVNode(_toDisplayString(_ctx.$t('effects')), 1)])]), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.effects, (effect, i) => {
        return _openBlock(), _createElementBlock("li", {
          key: i,
          class: "flex flex-row items-center"
        }, [_createElementVNode("div", {
          class: _normalizeClass(["flex font-bold w-14 justify-end mr-2", {
            'text-green-400': !effect.negative,
            'text-red-400': effect.negative
          }])
        }, [_createElementVNode("span", null, "+" + _toDisplayString(_ctx.$n(effect.value)), 1), effect.percent ? (_openBlock(), _createElementBlock("span", _hoisted_2, "%")) : _createCommentVNode("", true)], 2), _createElementVNode("div", null, _toDisplayString(effect.label), 1)]);
      }), 128))])]);
    };
  }
});